import styled from "styled-components";
import Headline from "@adecco/base-app/src/components/atoms/Headline/Headline";
import Icon from "@adecco/base-app/src/components/atoms/Icon/Icon";
import { copytext } from "@adecco/base-app/src/styles/typography";
import Container from "@adecco/base-app/src/components/atoms/Container/Container";
import { moreThan } from "@adecco/base-app/src/constants/breakpoints/breakpoints";

interface LinkProps {
  linkTitle: string;
  linkUrl: string;
  target?: string | undefined;
}

export interface LinkListProps {
  heading: string | undefined;
  linkList: Array<LinkProps>;
  centeredHeadline?: boolean;
}

const Wrapper = styled(Container)`
  text-align: left;
`;

const StyledHeadline = styled(Headline)`
  font-family: ${(props) => props.theme.fonts.HeadlineBold};
  font-weight: ${(props) => props.theme.fontWeights.headline};
  margin-bottom: ${(props) => props.theme.margins.linkListHeadline};
  font-size: ${(props) => props.theme.fontSizes.headline2};
  line-height: ${(props) => props.theme.lineHeights.headline2};

  ${moreThan("md")} {
    font-size: ${(props) => props.theme.fontSizes.headline2WideScreen};
    line-height: ${(props) => props.theme.lineHeights.headline2WideScreen};
  }
`;

export const OrderedList = styled.ol`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

export const ListItem = styled.li`
  text-align: left;
  width: 275px;
  min-height: 45px;
  display: flex;
  align-items: center;
  word-break: break-word;

  ${moreThan("md")} {
    width: 33%;
  }
`;

const StyledIcon = styled(Icon)`
  margin-right: ${(props) => props.theme.margins.linkListIcon};
`;

const StyledTextLink = styled.a`
  ${copytext};
  text-decoration: none;
  font-size: ${(props) => props.theme.fontSizes.linkList};
  font-weight: ${(props) => props.theme.fontWeights.textLink};
  color: ${(props) => props.theme.colors.black};
`;

const LinkList: React.FC<LinkListProps> = ({ heading, linkList, centeredHeadline }) => {
  return (
    <Wrapper>
      {heading && (
        <StyledHeadline skin={2} centered={centeredHeadline}>
          {heading}
        </StyledHeadline>
      )}
      <OrderedList>
        {linkList.map((data, index) => (
          <ListItem key={index}>
            <div>
              <StyledIcon name="arrow-right-red" width={20} height={20} />
            </div>
            <StyledTextLink href={data.linkUrl} target={data.target}>
              {data.linkTitle}
            </StyledTextLink>
          </ListItem>
        ))}
      </OrderedList>
    </Wrapper>
  );
};

export default LinkList;
